/**
 * It reads app version from the package.json file located in the root directory
 */
import rootPackageJson from '@root-package-json'

export const APP_VERSION = rootPackageJson.version
